<header class="flex items-center mb-4">
  <app-button variant="secondary" routerLink="../requestlist" queryParamsHandling="merge" customClass="mr-4">
    {{ 'CREATE_REQUEST.HEADER.BACK' | translate }}
  </app-button>
  <h2>{{ 'CREATE_REQUEST.HEADER.TITLE' | translate }}</h2>
</header>

<form class="content-card p-6" [formGroup]="requestForm" (ngSubmit)="onSubmit()">
  <div class="flex flex-row">
    <div class="input-container mb-4">
      <app-input
        id="name"
        [label]="'CREATE_REQUEST.FORM.NAME_LABEL' | translate"
        formControlName="name"
        [placeholder]="'CREATE_REQUEST.FORM.NAME_PLACEHOLDER' | translate"
        [error]="requestForm.get('name')?.invalid && requestForm.get('name')?.touched ? ('CREATE_REQUEST.FORM.NAME_REQUIRED' | translate) : null"
        [reserveErrorSpace]="false"
        *appSkeleton="loadingSourceTypes()"
      ></app-input>
    </div>
  </div>

  <div class="flex flex-wrap w-full border-l-4 border-primary ml-2 mb-8 relative bg-gray border-radius">
    <h3 class="w-full pl-2">{{ 'CREATE_REQUEST.FORM.EXTERNAL_SOURCE' | translate }}</h3>
    <div class="input-container">
      <app-select
        variant="form"
        [label]="'CREATE_REQUEST.FORM.SELECT_TYPE' | translate"
        [placeholder]="'CREATE_REQUEST.FORM.SELECT_FILES' | translate"
        formControlName="typeSource1"
        [items]="externalSourcetypes()"
        bindLabel="name"
        bindValue="code"
        [searchable]="true"
        [allowDeselect]="false"
        (selectionChange)="setMasterSourceTypes($event)"
        [error]="requestForm.get('typeSource1')?.invalid && requestForm.get('typeSource1')?.touched ? ('CREATE_REQUEST.FORM.TYPE_REQUIRED' | translate) : null"
        [reserveErrorSpace]="false"
        *appSkeleton="loadingSourceTypes()"
      ></app-select>
    </div>
    @if (requestForm.get('typeSource1')?.value) {
    <div class="input-container">
      <label class="label">{{ 'CREATE_REQUEST.FORM.SOURCE_FILE' | translate }} </label>
      <input class="input" aria-describedby="user_avatar_help" type="file" formControlName="source1"
        (change)="handleFileInput($event, 0, requestForm.value.typeSource1)" [accept]="acceptedFileTypes[0]" multiple />
      @if (requestForm.get('source1')?.invalid && requestForm.get('source1')?.touched) {
      <span class="text-error">
        {{ 'CREATE_REQUEST.FORM.SOURCE_FILE_REQUIRED' | translate }}
      </span>
      }
    </div>
    }
    <div class="w-full pl-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-2">
      @for(externalSourceType of selectedExternalSourceTypes(); track externalSourceType){
      @for(file of externalSourceType.files; track file.name){
      <app-display-file [filename]="file.name"></app-display-file>
      }
      }
    </div>
  </div>

  <div class="flex flex-wrap w-full border-l-4 border-primary ml-2 mb-8 relative bg-gray border-radius">
    <h3 class="w-full pl-2">{{ 'CREATE_REQUEST.FORM.INTERNAL_SOURCE' | translate }}</h3>
    <div class="input-container">
      <app-select
        variant="form"
        [label]="'CREATE_REQUEST.FORM.SELECT_TYPE' | translate"
        [placeholder]="'CREATE_REQUEST.FORM.SELECT_FILES' | translate"
        formControlName="typeSource2"
        [items]="internalSourceTypeItems"
        bindLabel="name"
        bindValue="code"
        [searchable]="false"
        [allowDeselect]="false"
        [error]="requestForm.get('typeSource2')?.invalid && requestForm.get('typeSource2')?.touched ? ('CREATE_REQUEST.FORM.TYPE_REQUIRED' | translate) : null"
        [reserveErrorSpace]="false"
        *appSkeleton="loadingSourceTypes()"
      ></app-select>
    </div>
    @if (!isVirtual && requestForm.get('typeSource2')?.value) {
    <div class="input-container">
      <label class="label"> {{ 'CREATE_REQUEST.FORM.SOURCE_FILE' | translate }} </label>
      <input class="input" aria-describedby="user_avatar_help" type="file" formControlName="source2"
        (change)="handleFileInput($event, 1, requestForm.value.typeSource2)" [accept]="acceptedFileTypes[1]" multiple />
      @if (requestForm.get('source2')?.invalid && requestForm.get('source2')?.touched) {
      <span class="text-error">
        {{ 'CREATE_REQUEST.FORM.SOURCE_FILE_REQUIRED' | translate }}
      </span>
      }
    </div>
    }
    <div class="w-full pl-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-2">
      @for(internalSourceType of selectedInternalSourceTypes(); track internalSourceType){
      @for(file of internalSourceType.files; track file.name){
      <app-display-file [filename]="file.name"></app-display-file>
      }
      }
    </div>
  </div>

  @if (isVirtual) {
  <div class="flex flex-col space-y-4 w-full ml-2 mb-8">
    @for(item of sourceTypesBundle(); track item.id; let i = $index) {
    <div class="flex flex-row items-center justify-center">
      <label class="basis-1/3 label"> {{item.name}}</label>
      <input class="basis-2/3 input" aria-describedby="user_avatar_help" type="file" formControlName="source2"
        (change)="handleFileInput($event, i+2, item.code)" multiple [accept]="getAcceptedFormats(item.sourceFormat)" />
    </div>
    }
  </div>
  }

  @if (loading()) {
  <div class="m-2">
    <div role="status">
      <app-loading-spinner class="w-8 h-8"></app-loading-spinner>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  }
  @if (errorMsg !== '') {
  <div class="block bg-error-light text-error p-2 my-2 border-radius">
    {{ errorMsg }}
  </div>
  }
  <app-button type="submit" [loading]="loading()" [disabled]="requestForm.invalid">
    {{ 'CREATE_REQUEST.FORM.SUBMIT' | translate }}
  </app-button>
</form>